import { createSelector } from '@opengov/compose-app/reselect';
import { produce } from 'immer';

import { lensSelector } from './lensState';

export const selectLensesWithColumns = createSelector(lensSelector, (state) =>
  produce(state.lensesWithColumns, (draft) => {
    draft.sort((first, second) => Date.parse(second.dataUpdatedAt) - Date.parse(first.dataUpdatedAt));
  })
);

export const selectLensesMap = createSelector(lensSelector, (state) => {
  return state.lenses.reduce((acc, lens) => {
    acc[lens.id] = lens;
    return acc;
  }, {});
});

export const selectIsLoadingLensesWithColumns = createSelector(
  lensSelector,
  (state) => !!state.lensesWithColumnsLoadingQueue.length
);

export const selectLoadingLensesWithColumnIds = createSelector(
  lensSelector,
  (state) => state.lensesWithColumnsLoadingQueue
);

export const selectEntityLenses = createSelector(lensSelector, (state) => state.lenses);

export const selectIsLoadingEntityLenses = createSelector(lensSelector, (state) => state.lensesLoading);
